import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} EV Dashboard. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
